import React from 'react';

const Footer = () => (
  <footer>
    <p className="fter author">
      Made by
      <a href="https://github.com/rdnrn"> Nana</a>
    </p>
    <p className="fter"><a href="https://icons8.com/icon/DchOf6erOUjJ/calculator">Calculator icon by Icons8</a></p>
  </footer>
);

export default Footer;
